import type { Meta, StoryObj } from "@storybook/react";

import type { ChannelPreviewCardProps } from "@/ui/components/messages/cards/ChannelPreviewCard";
import ChannelPreviewCard from "@/ui/components/messages/cards/ChannelPreviewCard";

const StoryMeta: Meta<ChannelPreviewCardProps> = {
  title: "Components/Messages/Channel Preview Card",
  component: ChannelPreviewCard,
  argTypes: {
    channelName: { control: "text" },
    channelUrl: { control: "text" },
    isGroupChannel: { control: "boolean" },
    isLastMessageFileMessage: { control: "boolean" },
    lastMessage: { control: "text" },
    lastMessageTime: { control: "text" },
    members: { control: "object" },
    onSelect: { action: "selected" },
    unreadMessageCount: { control: "number" },
  },
  args: {
    channelName: "Psychiatry Team",
    channelUrl: "channel-url",
    isGroupChannel: false,
    isLastMessageFileMessage: false,
    lastMessage: "thank you so much robert, that really helped",
    lastMessageTime: "Yesterday",
    members: [
      {
        userId: "1",
        userName: "Adrien Bahringer",
        userType: "provider",
      },
      {
        userId: "2",
        userName: "Heaven Conn",
        userType: "provider",
      },
    ],
    providerMembersDescription: "Adrien Bahringer, Heaven Conn",
    unreadMessageCount: 0,
  },
};

type Story = StoryObj<ChannelPreviewCardProps>;

const Primary: Story = {};

const GroupChannel: Story = {
  args: {
    isGroupChannel: true,
  },
};

const UnreadMessages: Story = {
  args: {
    unreadMessageCount: 1,
  },
};

const FileMessage: Story = {
  args: {
    isLastMessageFileMessage: true,
  },
};

export { FileMessage, GroupChannel, Primary, UnreadMessages };
export default StoryMeta;
